import type {EffectCallback} from 'react';
import {useEffect, useRef} from 'react';

// Like useEffect, but only called for updates after the initial render.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useUpdateEffect(effect: EffectCallback, dependencies: any[]) {
  const isInitialMount = useRef(true);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const lastDeps = useRef<any[] | null>(null);

  useEffect(() => {
    isInitialMount.current = true;
    return () => {
      isInitialMount.current = false;
    };
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      isInitialMount.current = false;
    } else if (
      !lastDeps.current ||
      dependencies.some(
        (dep, i) =>
          !Object.is(
            dep,
            // @ts-expect-error - Element implicitly has an 'any' type because expression of type 'number' can't be used to index type 'MutableRefObject<any[] | null>'
            lastDeps[i],
          ),
      )
    ) {
      effect();
    }
    lastDeps.current = dependencies;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
